import { e as c } from "./class-map-3ADKve8g.js";
import { o as k } from "./if-defined-rXcLNTzN.js";
import { P as u, A as d, b as t, n as r, t as m } from "./element-CV9utnHJ.js";
import { P as $ } from "./pkt-slot-controller-D7CrjM52.js";
import { e as y, n as _ } from "./ref-Dma3n3i8.js";
import "./icon-D0IQAVwS.js";
import "./tag-DZPqFiem.js";
import "./heading-D9R5UBcv.js";
const b = { layout: { default: "vertical" }, skin: { type: ["outlined", "outlined-beige", "gray", "blue", "beige", "green"], default: "outlined" }, padding: { default: "default" } }, p = {
  props: b
};
var f = Object.defineProperty, S = Object.getOwnPropertyDescriptor, i = (e, s, l, o) => {
  for (var n = o > 1 ? void 0 : o ? S(s, l) : s, h = e.length - 1, g; h >= 0; h--)
    (g = e[h]) && (n = (o ? g(s, l, n) : g(n)) || n);
  return o && n && f(s, l, n), n;
};
let a = class extends u {
  //Constructor
  constructor() {
    super(), this.defaultSlot = y(), this.ariaLabel = "", this.metaLead = null, this.borderOnHover = !0, this.clickCardLink = null, this.metaTrail = null, this.layout = p.props.layout.default, this.heading = "", this.headinglevel = 3, this.image = {
      src: "",
      alt: ""
    }, this.imageShape = "square", this.openLinkInNewTab = !1, this.padding = p.props.padding.default, this.skin = p.props.skin.default, this.subheading = "", this.tagPosition = "top", this.tags = [], this.slotController = new $(this, this.defaultSlot);
  }
  connectedCallback() {
    super.connectedCallback();
  }
  // Render methods
  // Main render method
  // prettier-ignore
  render() {
    var o, n;
    const e = {
      "pkt-card": !0,
      [`pkt-card--${this.skin}`]: this.skin,
      [`pkt-card--${this.layout}`]: this.layout,
      [`pkt-card--padding-${this.padding}`]: this.padding,
      "pkt-card--border-on-hover": this.borderOnHover
    }, s = ((o = this.ariaLabel) == null ? void 0 : o.trim()) || (this.heading ? `${this.heading} lenkekort` : "lenkekort"), l = ((n = this.ariaLabel) == null ? void 0 : n.trim()) || (this.heading ? this.heading : "kort");
    return t`
      <article
        class=${c(e)}
        aria-label=${k(this.clickCardLink ? s : l)}
      >
        ${this.renderImage()}
        <div class="pkt-card__wrapper">
          ${this.tagPosition === "top" ? this.renderTags() : d} 
          ${this.renderHeader()}
          ${this.renderSlot()} 
          ${this.tagPosition === "bottom" ? this.renderTags() : d}
          ${this.renderMetadata()}
        </div>
      </article>
    `;
  }
  // Render methods for different parts of the card
  renderImage() {
    const e = {
      "pkt-card__image": !0,
      [`pkt-card__image-${this.imageShape}`]: this.imageShape
    };
    return t`
      ${this.image.src && t`
        <div class=${c(e)}>
          <img src=${this.image.src} alt=${this.image.alt || ""} />
        </div>
      `}
    `;
  }
  // Do not render heading if link is present, render link heading instead
  // Combine the rendering for headings into a renderHeader method
  renderHeading() {
    return t`
      ${this.heading && !this.clickCardLink ? t`
            <pkt-heading
              class="pkt-card__heading"
              .level=${this.headinglevel || 3}
              size="medium"
              nospacing
              weight="regular"
            >
              ${this.heading}
            </pkt-heading>
          ` : d}
    `;
  }
  renderLinkHeading() {
    return t`
      ${this.clickCardLink ? t`
            <pkt-heading
              class="pkt-card__link-heading pkt-card__heading"
              .level=${this.headinglevel || 3}
              size="medium"
              weight="regular"
              nospacing
            >
              <a
                class="pkt-card__link"
                href=${this.clickCardLink}
                target=${this.openLinkInNewTab ? "_blank" : "_self"}
                >${this.heading}</a
              >
            </pkt-heading>
          ` : d}
    `;
  }
  renderSubheading() {
    return t`
      ${this.subheading ? t` <p class="pkt-card__subheading ">${this.subheading}</p> ` : d}
    `;
  }
  // Render header
  // prettier-ignore
  renderHeader() {
    const e = !!this.heading || !!this.subheading;
    return t`
      ${e ? t`
            <header class="pkt-card__header">
              ${this.renderHeading()} 
              ${this.renderLinkHeading()} 
              ${this.renderSubheading()}
            </header>
          ` : d}
    `;
  }
  renderTags() {
    const e = {
      "pkt-card__tags": !0,
      [`pkt-card__tags-${this.tagPosition}`]: this.tagPosition
    };
    return t`
      ${this.tags.length > 0 ? t`
            <div
              class=${c(e)}
              role="list"
              aria-label=${this.tags.length > 1 ? "merkelapper" : "merkelapp"}
            >
              ${this.tags.map(
      (s) => t`
                  <pkt-tag
                    role="listitem"
                    textStyle="normal-text"
                    size="medium"
                    skin=${k(s.skin)}
                    iconName=${k(s.iconName)}
                  >
                    <span>${s.text}</span>
                  </pkt-tag>
                `
    )}
            </div>
          ` : d}
    `;
  }
  renderSlot() {
    return t`
      ${this.defaultSlot && t`<section class="pkt-card__content" ${_(this.defaultSlot)}></section>`}
    `;
  }
  renderMetadata() {
    return t`
      ${this.metaLead || this.metaTrail ? t`
            <footer class="pkt-card__metadata">
              ${this.metaLead ? t`<span class="pkt-card__metadata-lead">${this.metaLead}</span>` : d}
              ${this.metaTrail ? t`<span class="pkt-card__metadata-trail">${this.metaTrail}</span>` : d}
            </footer>
          ` : d}
    `;
  }
};
i([
  r({ type: String })
], a.prototype, "ariaLabel", 2);
i([
  r({ type: String })
], a.prototype, "metaLead", 2);
i([
  r({ type: Boolean })
], a.prototype, "borderOnHover", 2);
i([
  r({ type: String, reflect: !0 })
], a.prototype, "clickCardLink", 2);
i([
  r({ type: String })
], a.prototype, "metaTrail", 2);
i([
  r({ type: String })
], a.prototype, "layout", 2);
i([
  r({ type: String })
], a.prototype, "heading", 2);
i([
  r({ type: Number })
], a.prototype, "headinglevel", 2);
i([
  r({ type: Object })
], a.prototype, "image", 2);
i([
  r({ type: String })
], a.prototype, "imageShape", 2);
i([
  r({ type: Boolean })
], a.prototype, "openLinkInNewTab", 2);
i([
  r({ type: String })
], a.prototype, "padding", 2);
i([
  r({
    type: String,
    converter: {
      fromAttribute: (e) => {
        const s = p.props.skin.type;
        return e && s.includes(e) ? e : (e && !s.includes(e) && console.warn(
          `Invalid skin value "${e}". Using default skin "${p.props.skin.default}".`
        ), p.props.skin.default);
      },
      toAttribute: (e) => e
    }
  })
], a.prototype, "skin", 2);
i([
  r({ type: String })
], a.prototype, "subheading", 2);
i([
  r({ type: String })
], a.prototype, "tagPosition", 2);
i([
  r({ type: Array })
], a.prototype, "tags", 2);
a = i([
  m("pkt-card")
], a);
export {
  a as P
};
